<template lang="pug">
#modal-diagnostico-socioambiental
    el-dialog(
        :title="$t('mensagens.pessoas.diagnosticoSocioambiental')",
        width='800px',
        :visible.sync='mostrar',
        :before-close='fechar'
    )
        p
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.nome') }}:
            |
            | {{ dadosRepresentante.nome }}

        p
            b {{ $t('mensagens.diagnosticoSocioambiental.propriedadesCamada.documento') }}:
            |
            | {{ dadosRepresentante.cpfCnpj }}

        p(v-if='dadosRepresentante.email')
            b {{ $t('mensagens.comuns.email') }}:
            |
            | {{ dadosRepresentante.email }}

        div.d-flex.flex-column(v-if='protocolos.length > 1 && !consultaRealizada')
            b {{ $t('mensagens.pessoas.selecioneProtocoloParaAnalisar') }}

            el-select(
                :disabled='protocolos.length === 1',
                v-model='selectedProtocolo'
            )
                el-option(
                    v-for='protocolo in protocolos',
                    :key='protocolo.codigo',
                    :label='protocolo.descricao',
                    :value='protocolo.codigo'
                )

        div(v-if='consultaRealizada && protocoloUtilizadoFormatado')
            div.d-flex.align-items-center
                b {{ $t('mensagens.pessoas.protocoloUtilizado') }}
                i.el-input__icon.el-icon-info(
                    slot='suffix',
                    :title="$t('mensagens.blocoFiltros.infos.selecionarProtocoloParaDiagnostico')"
                )
            p {{ protocoloUtilizadoFormatado }}

        .modal-diagnostico-socioambiental__btn-confimar.mt-3(
            v-if='!consultaRealizada'
        )
            BaseButton(
                type='primary',
                size='large',
                key='btnRealizarDiagnostico',
                @click='realizarDiagnosticoSocioambietal'
            ) {{ $t('mensagens.pessoas.realizarDiagnosticoSocioambiental') }}

        template(v-else)
            h3.font-weight-bold Análise Socioambiental
            DiagnosticoSocioambiental.mb-3(
                :dadosConsulta='resultadoDiagnostico',
                :cpfCnpj='dadosRepresentante.cpfCnpj',
                :habilitar-sinal-aviso='true'
            )

            .modal-diagnostico-socioambiental__btn-exportacao
                BaseButton(
                    type='primary',
                    key='btnMarcarExportcao',
                    size='mini',
                    @click='marcarExportacaoDiagnosticoPdf',
                    :loading='loadingPDF'
                )
                    | {{ $t('mensagens.pessoas.marcarParaExportacao') }}

                BaseButton(
                    type='primary',
                    key='btnExportar',
                    size='mini',
                    @click='exportarPdfDiagnosticoSocio',
                    :loading='loadingPDF'
                )
                    | {{ $t('mensagens.pessoas.exportarDiagnostico') }}

                footer(slot='footer')
                    BaseButton(size='mini', @click='fechar') {{ $t('mensagens.comuns.voltar') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import DiagnosticoSocioambientalService from '@/services/DiagnosticoSocioambientalService';

import { ProtocolosService } from '@/services/ProtocolosService';

import DiagnosticoSocioambiental from '@/components/diagnosticoSocioambiental/index.vue';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

import formatters from '@/utils/formatters';
import { retryOperation } from '@/utils/retry-operation';
import { connect, subscribe, disconnect } from '@/utils/websocket';

export default {
    name: 'DiagnosticoSociambientealRepresentante',

    components: {
        DiagnosticoSocioambiental,
        BaseButton
    },

    props: {
        mostrar: {
            type: Boolean,
            required: true
        },

        dadosRepresentante: {
            type: Object,
            required: true
        },

        confirmar: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            resultadoDiagnostico: {},
            consultaRealizada: false,
            loadingPDF: false,
            protocolos: [],
            selectedProtocolo: '',
            protocoloUtilizado: '',
            protocoloUtilizadoFormatado: ''
        };
    },

    computed: {
        ...mapGetters(['usuarioLogado'])
    },

    watch: {
        mostrar() {
            if (this.mostrar && !this.confirmar && (this.protocolos.length === 1)) {
                this.realizarDiagnosticoSocioambietal();
            }
        }
    },

    async mounted() {
        await this.buscarProtocolosPorUsuario();
    },

    methods: {
        ...mapActions(['setMarcarExportar_PDF']),

        fechar() {
            this.resultadoDiagnostico = {};
            this.consultaRealizada = false;
            this.$emit('fechar');
        },

        async realizarDiagnosticoSocioambietal() {
            const numeroCpfCnpj = formatters.documentoFormatToNumeral(
                this.dadosRepresentante.cpfCnpj
            );
            const { data } = await DiagnosticoSocioambientalService.consultar(
                'CPF_CNPJ',
                numeroCpfCnpj,
                true,
                true,
                null,
                this.selectedProtocolo ? this.selectedProtocolo : null
            );

            data.dataCAR.forEach(diagnostico => {
                if (diagnostico.camada.nome === 'Áreas embargadas') {
                    diagnostico.camada.nome = 'Áreas Embargadas (IBAMA)';
                } else if (
                    diagnostico.camada.nome === 'Monitoramento Desmatamento'
                ) {
                    diagnostico.camada.nome = 'Desmatamento Lyra';
                }
            });

            this.protocoloUtilizado = data.protocolo;
            this.protocoloUtilizadoFormatado = data.protocoloDescricao;

            this.resultadoDiagnostico = { diagnostico: data.dataCAR };
            this.consultaRealizada = true;
        },

        async exportarPdfDiagnosticoSocio() {
            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.pessoas.naoFoiPossivelConectarApiPdf')
                });
                return;
            }

            try {
                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/exportar/pdf/diagnostico/socio`,
                    response => {
                        if (response) {
                            const linkSource = `data:application/pdf;base64,${response}`;
                            const link = document.createElement('a');
                            const fileName = this.$t('mensagens.diagnosticoSocioambiental.pdfTitulo');
                            link.href = linkSource;
                            link.download = fileName;
                            link.click();
                            link.remove();
                        } else {
                            this.$notify.error({
                                message: this.$t('mensagens.pessoas.naoFoiPossivelExportarPdf')
                            });
                        }
                        this.loadingPDF = false;
                        disconnect();
                    }
                );

                this.loadingPDF = true;
                const cpfCnpj = formatters.documentoFormatToNumeral(
                    this.dadosRepresentante.cpfCnpj
                );

                const params = {
                    idTerritorio: null,
                    tipoDocumento: 'CPF_CNPJ',
                    documento: cpfCnpj,
                    camadas: null,
                    nome: 'CPF/CNPJ ' + cpfCnpj,
                    buffer: null,
                    protocolo: this.protocoloUtilizado
                };

                const dados = [];
                dados.push(params);

                retryOperation(
                    DiagnosticoSocioambientalService.exportarPdf,
                    dados,
                    5000,
                    10
                );
            } catch (error) {
                this.$notify.error({
                    message: this.$t('mensagens.pessoas.naoFoiPossivelExportarPdf')
                });
                disconnect();
            }
        },

        marcarExportacaoDiagnosticoPdf() {
            const cpfCnpj = formatters.documentoFormatToNumeral(
                this.dadosRepresentante.cpfCnpj
            );
            const params = {
                idLista: Math.floor(Date.now() * Math.random()).toString(36),
                idTerritorio: null,
                tipoDocumento: 'CPF_CNPJ',
                documento: cpfCnpj,
                camadas: null,
                nome: 'CPF/CNPJ ' + cpfCnpj,
                buffer: null,
                protocolo: this.protocoloUtilizado,
                protocoloFormatado: this.protocoloUtilizadoFormatado
            };

            this.setMarcarExportar_PDF(params);
        },

        async buscarProtocolosPorUsuario() {
            this.protocolos = await ProtocolosService.buscarProtocolosPorUsuario();
            this.selectedProtocolo = this.protocolos.find(p => p.protocoloPadrao === true).codigo;
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-diagnostico-socioambiental__btn-confimar {
    display: flex;
    justify-content: center;
}

.modal-diagnostico-socioambiental__btn-exportacao {
    display: flex;
    justify-content: flex-start;
    margin-top: 1.2rem;
}

footer {
    display: flex;
    justify-content: flex-end;
    margin-left: 25rem;
}
</style>
